import type { AppNotification, NotificationTopic } from '@gobingebox/shared';
import { apiFetch } from '@/lib/api';

export const notifyApi = {
  optIn: (topic: NotificationTopic, email: string) =>
    apiFetch<{ ok: boolean }>('/notify', { method: 'POST', body: JSON.stringify({ topic, email }) }),
};

/** In-app notification inbox. */
export const inboxApi = {
  list: () => apiFetch<{ unread: number; notifications: AppNotification[] }>('/me/notifications'),
  markAllRead: () => apiFetch<{ ok: boolean }>('/me/notifications/read', { method: 'POST', body: JSON.stringify({}) }),
  markRead: (id: string) =>
    apiFetch<{ ok: boolean }>(`/me/notifications/${id}/read`, { method: 'POST', body: JSON.stringify({}) }),
};
